// extracted by mini-css-extract-plugin
module.exports =  {"tooltip":"_7506d987b5--tooltip--Rln6T","arrow":"_7506d987b5--arrow--GMnRq"};